import { AllowedFileMIMEType, AllowedFileTypesEnum } from '../../legacy/shared-types';

export const getMIMEByExtension = (fileName: string) => {
  const extension = fileName.split('.').pop()?.toLowerCase() as AllowedFileTypesEnum;

  return AllowedFileMIMEType[extension] || '';
};

export function resolveFileMimeType(fileName: string, blob: Blob): string {
  const mimeFromExtension = getMIMEByExtension(fileName);
  if (mimeFromExtension) {
    return mimeFromExtension;
  }
  if (blob.type && blob.type !== 'application/octet-stream') {
    return blob.type;
  }
  return 'application/octet-stream';
}

export function openBlobInNewTab(blob: Blob, fileName: string): void {
  const mimeType = resolveFileMimeType(fileName, blob);
  const fileBlob = blob.type === mimeType ? blob : new Blob([blob], { type: mimeType });
  const url = window.URL.createObjectURL(fileBlob);
  window.open(url, '_blank', 'noopener,noreferrer');
}
